import { createLink } from "@tanstack/react-router";

import Button from "./Button";

export const ButtonLink = createLink(Button);
